export const CHART_WITH_RANGE_SELECTOR_CHART_MARGIN_TOP = 0;
export const CHART_WITHOUT_RANGE_SELECTOR_CHART_MARGIN_TOP = 20;
